import onscan from "onscan.js";
import { dateUtil } from "src/app/support/date-util";
// @ts-ignore
import interpretScan from "./gs1/gs1";
import { padStart } from "lodash";

export function scannerIsEnabled(): boolean {
  return onscan.isAttachedTo(document);
}

export function scannerEnable({
  onScan
}: {
  onScan: (scanCode: string) => void;
}): void {
  onscan.attachTo(document, {
    suffixKeyCodes: [13],
    reactToKeyDown: true,
    reactToPaste: false,
    captureEvents: false,
    onScan: (scanCode: string, quantity: number) => {
      onScan(scanCode);
    }
  });
}

export function scannderDisable(): void {
  if (scannerIsEnabled()) {
    onscan.detachFrom(document);
  }
}

export function scannerSimulate(scanCode: string): void {
  onscan.simulate(document, scanCode);
}

(<any>window)["scannerSimulate"] = scannerSimulate;

export enum SCANNER_AI_VALUES {
  GTIN = "01",
  USE_BY_OR_EXPIRY = "17",
  BATCH_LOT = "10",
  PRICE = "3922",
  NET_WEIGHT = "3923"
}

type ScannerDecodeRawResultItem = {
  ai: SCANNER_AI_VALUES;
  label: string;
  value: string;
};

export type ScannerDecodeResult = {
  upc?: string;
  gtin13?: string;
  gtin14?: string;
  originalGtinIs14: boolean;
  price?: string;
  batchLot?: string;
  useByOrExpiry?: string;
};

export async function scannerDecode(
  scanCode: string
): Promise<ScannerDecodeResult> {
  const resultScan: {
    errmsg?: Error;
    AIbrackets?: string;
    AIfnc1?: string;
    dl?: string;
    licensingMO?: string;
    ol?: ScannerDecodeRawResultItem[];
  } = <any>await interpretScan(scanCode);

  if (resultScan.errmsg) {
    throw resultScan.errmsg;
  }

  const useByOrExpiryRaw = resultScan?.ol?.find(
    (item: ScannerDecodeRawResultItem) =>
      item.ai === SCANNER_AI_VALUES.USE_BY_OR_EXPIRY
  )?.value;

  const useByOrExpiry = useByOrExpiryRaw
    ? dateUtil(useByOrExpiryRaw, "YYYY-MM-DD").isValid()
      ? dateUtil(useByOrExpiryRaw, "YYYY-MM-DD").toISOString()
      : dateUtil(useByOrExpiryRaw, "YYYY-MM").isValid()
        ? dateUtil(useByOrExpiryRaw, "YYYY-MM").toISOString()
        : undefined
    : undefined;

  const gtin = resultScan?.ol?.find(
    (item: ScannerDecodeRawResultItem) => item.ai === SCANNER_AI_VALUES.GTIN
  )?.value!;

  const originalGtinIs14 = scanCode.length === 14;

  const gtin13 = gtin.length === 14 ? gtin.substring(1) : gtin;
  const gtin14 = originalGtinIs14 ? scanCode : padStart(gtin13, 14, "0");

  const upc = scanCode?.length === 12 ? scanCode : undefined;

  return <ScannerDecodeResult>{
    scanCode,
    upc,
    originalGtinIs14,
    gtin13,
    gtin14,
    price: resultScan?.ol?.find(
      (item: ScannerDecodeRawResultItem) => item.ai === SCANNER_AI_VALUES.PRICE
    )?.value,
    batchLot: resultScan?.ol?.find(
      (item: ScannerDecodeRawResultItem) =>
        item.ai === SCANNER_AI_VALUES.BATCH_LOT
    )?.value,
    useByOrExpiry
  };
}
